import styled from "@emotion/styled"
import { useState } from "react"
import { useInView } from "react-intersection-observer"
import { transitionDelayTime, TransitionUp } from "ui"
import { useInViewConfig } from "ui/transitions/utils"
import BackCard from "./BackCard"
import FaceCard from "./FaceCard"
import { Team } from "./TeamTabs"

const OuterLayout = styled.div`
  width: 100%;
  display: flex;
`
const StyledTeamGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 32px;
  row-gap: 24px;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    width: max-content;
    grid-template-columns: 1fr 1fr 1fr;
  }
`

const StyledItem = styled.div<{ $isFlipped?: boolean }>`
  border-radius: 12px;
  height: 328px;
  width: 100%;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  transition: box-shadow 0.3s ease;
  /* cursor: pointer; */
  outline: none;
  cursor: default;
  ${({ theme }) => theme.breakpoints.up("md")} {
    width: 352px;
    height: 336px;
  }
  &:hover {
    box-shadow: 0px 4px 12px rgba(38, 48, 61, 0.25);
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primary.main};
    outline-offset: 2px;
  }
`

export default function TeamGrid({ data }: { data: Team[] }) {
  const { ref, inView } = useInView({ ...useInViewConfig, threshold: 0 })
  return (
    <OuterLayout ref={ref}>
      <TransitionUp $inView={inView} $delay={transitionDelayTime}>
        <StyledTeamGrid>
          {data.map((el, index) => {
            const [isFlipped, setIsFlipped] = useState(false)

            const handleClick = () => {
              setIsFlipped((prev) => !prev)
            }

            const handleKeyDown = (event: React.KeyboardEvent) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault()
                handleClick()
              }
            }

            return (
              <StyledItem
                key={index}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                $isFlipped={isFlipped}
                tabIndex={0}
                role="button"
                aria-label={`${el.teamName} מידע נוסף`}
              >
                <FaceCard el={el} />
                <BackCard el={el} isFlipped={isFlipped} />
              </StyledItem>
            )
          })}
        </StyledTeamGrid>
      </TransitionUp>
    </OuterLayout>
  )
}
